import { render, staticRenderFns } from "./machine_cnct.vue?vue&type=template&id=04bf1bda&"
import script from "./machine_cnct.vue?vue&type=script&lang=js&"
export * from "./machine_cnct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports